import React from 'react';
import isNumber from 'lodash/isNumber';
import classnames from 'classnames';
import Slider from 'rc-slider';

const SliderSelector = ({ options, value, onChange }) => {
  return (
    <div className={classnames("pap-slider-selector", { readonly: !onChange })}>
      { options.map((opt, i) => {
        return (
          <Slider
            key={i}
            marks={{ 0: opt[0].label, 5: "", 10: "", 15: "", 20: "", 25: "", 30: opt[1].label }}
            min={0}
            max={30}
            step={5}
            onChange={onChange? (v) => onChange(v, i) : undefined}
            defaultValue={15}
            value={isNumber(value[i])? value[i] : undefined}/>
        );
      }) }
    </div>
  );
}

export default SliderSelector;



// WEBPACK FOOTER //
// ./pap/components/common/slider_selector.jsx